import api from 'services/api';

interface DemoAccountRequest {
  account_name: string;
  admin_email: string;
  occupant_full_name: string;
  occupant_email: string;
  occupant_phone_number: string;
  building_names: string;
  image: string;
}

/* The function `createDemoAccount` is an asynchronous function that makes a POST request to the '/admin/demo' endpoint to create a new demo account. */
const createDemoAccount = async (demoAccountData: DemoAccountRequest) => {
  const response = await api.post<DemoAccountRequest>('/v2/api/admin/demo', demoAccountData);
  return response?.data;
};

const DemoAccountService = {
  createDemoAccount
};

export default DemoAccountService;
